import { Button } from "@/shared/components/ui/button";
import { Download } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { exportNotification } from "../../api/notifications";

export function NotificationHeader() {
  const navigate = useNavigate();

  const handleCreateNotification = () => {
    navigate(`/notifications/details`);
  };

  return (
    <div className="flex items-center justify-between mb-6">
      <h1 className="text-3xl font-bold">История push-уведомлений</h1>
      <div className="flex gap-3">
        {" "}
        <Button
          size="sm"
          className="bg-white hover:bg-gray-50 text-gray-700 border border-gray-300"
          onClick={handleCreateNotification}
        >
          Отправить push
        </Button>
        <Button
          onClick={exportNotification}
          size={"sm"}
          variant="default"
          className="gap-2"
        >
          <Download className="w-4 h-4" />
          Экспорт таблицы
        </Button>
      </div>
    </div>
  );
}
